import React, { Component } from 'react';
import "./css/style.css";

export default class ResetEmailSent extends Component {
    constructor(props) {
        super(props);
        this.state = props.location.state || { Email: 'your email address' };
    }
    render() {
        return (
            <div>
                <div className="login_register">
                    <div className="container">
                        <div className="entry">
                            <div className="head">
                                <div className="logoImage"></div>
                                <p>Reset password.</p>
                                <div style={{ textAlign: 'center' }}>
                                    <img src={require("./img/verify@2x.png")} alt='' style={{ maxHeight: "50%", maxWidth: "50%", width: 'auto', height: 'auto', margin: '0 auto' }} />
                                </div>
                                <p>
                                    We have sent an email to {this.state.Email}.
                            </p>
                                <p>
                                    Please check your email and click on the link to reset your account password.
                            </p>
                                <p>
                                    If you do not see the email, please check your spam or junk folders.
                            </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ResetEmailSent.js